import { Observable } from 'rxjs/Observable'
import { DataService } from 'core/data/service'

export class CepService extends DataService {

  constructor() {
    super()
  }

  buscarEnderecoPorCep(cep) {
    const options = {
      method: 'GET',
      url: `/endereco/localidades/${cep}`
    }

    return Observable
              .fromPromise(super.request(options));
  }
}






// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-pbm/pbm-funcional/cep/cep.service.js